import {
  ChargerAttributes,
  ChargerDisplayStatus,
  isChargerOffline,
  mapConnectorStatusToDisplay,
} from '../models/charger-model';
import { isCurrentlyUnavailable } from '../components/common/utils/unavailable-times-utils';

/**
 * Determines the display status for a charger based on registration,
 * connectivity, OCPP connector state, legacy flags, and unavailable windows.
 */
export const getChargerDisplayStatus = (
  charger: ChargerAttributes
): ChargerDisplayStatus => {
  if (charger.registration_status === 'pending_charger') {
    return 'Pending';
  }

  if (isChargerOffline(charger)) {
    return 'Charger Offline';
  }

  const connectorStatus =
    charger.ocpp_connector_status || charger.chargerState?.connector_status;
  if (connectorStatus) {
    return mapConnectorStatusToDisplay(connectorStatus);
  }

  if (charger.isOccupied === 1 || charger.is_enabled === false) {
    return 'In Use';
  }

  if (charger.is_currently_unavailable === true) {
    return 'Unavailable';
  }
  if (
    charger.is_currently_unavailable === undefined &&
    isCurrentlyUnavailable(charger.unavailable_times ?? null)
  ) {
    return 'Unavailable';
  }

  return 'Available';
};
